const bsb = [
  'whitespace',
  'bsb',
];

module.exports = {
  bsb,
};
